export enum AdvancedSearchDateInput {
  COMPLETION_DATE_START = 'completion_date_start',
  COMPLETION_DATE_END = 'completion_date_end'
}
